<p class="body-copy-md">
  Select specific dates for the trip and jump straight to members RSVPing.
</p>
@if (hasRangeData()) {
  @if (state | async; as vState) {
    <form class="form" [formGroup]="datesForm" (ngSubmit)="saveDates.next(true)">
      <div
        #errorSummary
        id="errorSummary"
        aria-live="polite"
        aria-atomic="true"
        tabindex="-1"
        class="form-errors">
        @if (vState.error) {
          <div class="form-error">
            <div class="icon icon-md icon-alert-circle"></div>
            <p class="error-message">{{ vState.error }}</p>
          </div>
        }
      </div>
      <at-availability-map [selectedDates]="initialDates()" [rangeForm]="datesForm"></at-availability-map>
      <div
        aria-live="polite"
        aria-atomic="true"
        tabindex="-1"
        class="form-errors">
        @if (
          datesForm.controls.start.touched &&
          datesForm.controls.start.hasError("required")
        ) {
          <div class="form-error">
            <div class="icon icon-md icon-alert-circle"></div>
            <p class="error-message">Start date is required</p>
          </div>
        }
        @if (
          datesForm.controls.start.touched &&
          datesForm.controls.start.hasError("minDate")
        ) {
          <div class="form-error">
            <div class="icon icon-md icon-alert-circle"></div>
            <p class="error-message">Start date must be in the future</p>
          </div>
        }
      </div>
      @if (isEditing()) {
        <div class="alert warning">
          <div class="icon icon-sm icon-alert-circle"></div>
          <p class="body-copy-sm alert-content">
            You are editing the trip dates. This
            <strong>requires all participants to RSVP again</strong>
            .
          </p>
        </div>
        <hr />
      }
      <div class="form-actions">
        <button class="button primary" [disabled]="datesForm.disabled">
          Set dates and notify members
        </button>
        <button
          class="button secondary"
          [disabled]="datesForm.disabled"
          type="button"
          (click)="saveDates.next(false)">
          Set trip dates
        </button>
        <a class="button tertiary" type="button" [routerLink]="moduleRootPath">
          Discard changes
        </a>
      </div>
    </form>
  }
} @else {
  @if (state | async; as vState) {
    <form class="form" [formGroup]="datesForm" (ngSubmit)="saveDates.next(true)">
      <div
        #errorSummary
        id="errorSummary"
        aria-live="polite"
        aria-atomic="true"
        tabindex="-1"
        class="form-errors">
        @if (vState.error) {
          <div class="form-error">
            <div class="icon icon-md icon-alert-circle"></div>
            <p class="error-message">{{ vState.error }}</p>
          </div>
        }
      </div>
      @let vInitialDates = initialDates();
      @if (vInitialDates) {
        <at-calendar-range-picker
          class="calendar"
          [selected]="vInitialDates"
          [startAt]="vInitialDates.start"
          [minDate]="minStartDate()"></at-calendar-range-picker>
      } @else {
        <at-calendar-range-picker
          class="calendar"
          [minDate]="minStartDate()"></at-calendar-range-picker>
      }
      <div
        aria-live="polite"
        aria-atomic="true"
        tabindex="-1"
        class="form-errors">
        @if (
          datesForm.controls.start.touched &&
          datesForm.controls.start.hasError("required")
        ) {
          <div class="form-error">
            <div class="icon icon-md icon-alert-circle"></div>
            <p class="error-message">Start date is required</p>
          </div>
        }
        @if (
          datesForm.controls.start.touched &&
          datesForm.controls.start.hasError("minDate")
        ) {
          <div class="form-error">
            <div class="icon icon-md icon-alert-circle"></div>
            <p class="error-message">Start date must be in the future</p>
          </div>
        }
      </div>
      @if (isEditing()) {
        <div class="alert warning">
          <div class="icon icon-sm icon-alert-circle"></div>
          <p class="body-copy-sm alert-content">
            You are editing the trip dates. This
            <strong>requires all participants to RSVP again</strong>
            .
          </p>
        </div>
        <hr />
      }
      <div class="form-actions">
        <button class="button primary" [disabled]="datesForm.disabled">
          Set dates and notify members
        </button>
        <button
          class="button secondary"
          [disabled]="datesForm.disabled"
          type="button"
          (click)="saveDates.next(false)">
          Set trip dates
        </button>
        <a class="button tertiary" type="button" [routerLink]="moduleRootPath">
          Discard changes
        </a>
      </div>
    </form>
  }
}